const src = import.meta.ROLLUP_FILE_URL_2ZEzIIM_atdpHcr$6kvj$Q;
export default {
  src,
  srcSet: src + " " + 302 + "w",
  width: 302,
  height: 314,
};